/**
 * Valence in the UI — the vocabulary from packages/shared/valence.js plus the
 * colours and the Finnish words participants see.
 *
 * Colour is the whole point of this file. A map where wanted and unwanted
 * consequences look identical makes the room read every branch to find the one
 * that matters; colouring them means the shape of the argument is visible from
 * across the space, which is what a wall display is for.
 *
 * Deliberately not red/green alone — a third of a workshop cannot reliably tell
 * those apart, and the report prints in greyscale. Each state carries a shape
 * cue as well (see `mark`), the same way the loop badge does not rely on colour
 * to say R or B.
 */
export {
  VALENCE,
  VALENCE_KEYS,
  VALENCE_SOURCES,
  normalizeValence,
  propagateValence,
  detectChoicePoints,
} from '../../../../packages/shared/valence.js';

/** Display treatment per state. Keys match packages/shared/valence.js. */
export const VALENCE_STYLE = {
  wanted: {
    label: 'Toivottu',
    mark: '↑',
    color: '#34D399',
    line: 'rgba(52, 211, 153, 0.55)',
    tint: 'rgba(52, 211, 153, 0.10)',
  },
  unwanted: {
    label: 'Ei-toivottu',
    mark: '↓',
    color: '#F87171',
    line: 'rgba(248, 113, 113, 0.55)',
    tint: 'rgba(248, 113, 113, 0.10)',
  },
  unknown: {
    label: 'Epäselvä',
    mark: '?',
    color: '#94A3B8',
    line: 'rgba(148, 163, 184, 0.40)',
    tint: 'rgba(148, 163, 184, 0.08)',
  },
};

/** Nodes nobody has judged render as the map always has — no colour claim. */
export const VALENCE_UNJUDGED = {
  label: 'Ei arvioitu',
  mark: '',
  color: 'rgba(255, 255, 255, 0.55)',
  line: 'rgba(255, 255, 255, 0.18)',
  tint: 'transparent',
};

export function valenceStyle(valence) {
  return VALENCE_STYLE[valence] || VALENCE_UNJUDGED;
}
